import { render, staticRenderFns } from "./Diversity.vue?vue&type=template&id=209fcb28&scoped=true"
import script from "./Diversity.vue?vue&type=script&lang=js"
export * from "./Diversity.vue?vue&type=script&lang=js"
import style0 from "./Diversity.vue?vue&type=style&index=0&id=209fcb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209fcb28",
  null
  
)

export default component.exports